import { render, staticRenderFns } from "./wxgame-playable-end-time.vue?vue&type=template&id=dd108e5e&scoped=true"
import script from "./wxgame-playable-end-time.vue?vue&type=script&setup=true&lang=js"
export * from "./wxgame-playable-end-time.vue?vue&type=script&setup=true&lang=js"
import style0 from "./wxgame-playable-end-time.vue?vue&type=style&index=0&id=dd108e5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd108e5e",
  null
  
)

export default component.exports